import _ from "lodash"
import { diff } from '../lib/render-object'
import { ChangeProps } from './change-renderer'
import codeService from 'data/codes'
import React from "react"

const mapper = (text) => {
  return {
    folderpath: 'Folder Path',
  }[text] || _.startCase(text)
}

const resource_m = (text) => {
  return {
  }[text] || _.startCase(text)
}

type EventChange = {
  event: string
  data: object
}

const alwaysDrop = ['externalreference', 'organizationid']

export const diffif = (props: ChangeProps) => {
  if (props.user.service !== 'copy-service') return null
  return () => {
    const change = JSON.parse(props.change) as EventChange
    return {
      atRest: props.resource == 'folder' ? 'Created Folder Copy' : <em style={{color: 'gray'}}>Copied</em>,
      diffs: diff(null, change.data, mapper, null, alwaysDrop),
      ...props
    }
  }
}
